import { fetchData } from "../../../utils/utils";
import { RESOURCES_URL } from "../../../context/constants";
import { useQueryClient } from "@tanstack/react-query";

export const useAirlinesOptions = () => {
  const queryClient = useQueryClient();

  const loadAirlinesOptions = async (inputValue) => {
    return queryClient.fetchQuery({
      queryKey: ['autocomplete_airlines', inputValue],
      queryFn: async () => {
        const response = await fetchData(
          {
            sEvent:"GETAIRLINES",
            sSearchCriteria: inputValue
          },
          `${RESOURCES_URL}GetAirlines`,
          "post"
        );
        
        return response?.map((airline) => ({
          value: airline.airlineCode,
          label: `${airline.airlineCode} ${airline.airlineName}`,
        })) || [];
      },
      staleTime: 1000 * 60 * 30, // Cache for 30 minutes
    });
  };

  return { loadAirlinesOptions }
}